import { defineComponent, computed, useTemplateRef, onMounted, onBeforeUnmount, createBlock, openBlock, mergeProps, isRef } from "vue";
import UInputNumber from "@nuxt/ui/components/InputNumber.vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ inheritAttrs: false },
  __name: "NumberField",
  props: {
    modelValue: {},
    precision: {},
    min: {},
    max: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const value = computed(() => toNumber(props.modelValue));
    function toNumber(raw) {
      if (raw === null || raw === void 0 || raw === "") return null;
      const parsed = Number(raw);
      return Number.isNaN(parsed) ? null : parsed;
    }
    const formatter = computed(() => new Intl.NumberFormat("en-US", { maximumFractionDigits: props.precision, useGrouping: false }));
    function shown(number) {
      if (number === null) return "";
      const text = formatter.value.format(number);
      return text === "-0" ? "0" : text;
    }
    function untouched(number) {
      return number === null ? null : Math.min(Math.max(number, props.min ?? -Infinity), props.max ?? Infinity);
    }
    let edited = false;
    function commit(next) {
      const committed = next ?? null;
      const typed = edited;
      edited = false;
      if (!typed && shown(committed) === shown(untouched(value.value))) return;
      emit("update:modelValue", committed);
    }
    const field = useTemplateRef("field");
    __expose({ inputRef: computed(() => {
      var _a;
      return ((_a = field.value) == null ? void 0 : _a.inputRef) ?? null;
    }) });
    const CARET_KEYS = ["Home", "End", "PageUp", "PageDown"];
    function onKeydown(event) {
      if (CARET_KEYS.includes(event.key)) event.stopPropagation();
    }
    let probing = false;
    function onBeforeinput(event) {
      const input = event.target;
      if (probing || !(input instanceof HTMLInputElement) || event.isComposing || !event.data) return;
      const data = event.data.replace(/,/g, ".");
      const next = input.value.slice(0, input.selectionStart ?? void 0) + data + input.value.slice(input.selectionEnd ?? void 0);
      const point = next.lastIndexOf(".");
      const tooPrecise = point !== -1 && next.length - point - 1 > props.precision;
      if (!tooPrecise && data === event.data) return;
      event.preventDefault();
      event.stopPropagation();
      if (tooPrecise) return;
      probing = true;
      const accepted = input.dispatchEvent(new InputEvent("beforeinput", { data, inputType: "insertText", cancelable: true }));
      probing = false;
      if (accepted) document.execCommand("insertText", false, data);
    }
    onMounted(() => {
      var _a, _b;
      (_a = field.value) == null ? void 0 : _a.$el.addEventListener("keydown", onKeydown, true);
      (_b = field.value) == null ? void 0 : _b.$el.addEventListener("beforeinput", onBeforeinput, true);
    });
    onBeforeUnmount(() => {
      var _a, _b;
      (_a = field.value) == null ? void 0 : _a.$el.removeEventListener("keydown", onKeydown, true);
      (_b = field.value) == null ? void 0 : _b.$el.removeEventListener("beforeinput", onBeforeinput, true);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(UInputNumber, mergeProps({
        ref_key: "field",
        ref: field,
        "step-snapping": false,
        "disable-wheel-change": ""
      }, _ctx.$attrs, {
        locale: "en-US",
        "model-value": value.value,
        min: __props.min,
        max: __props.max,
        "format-options": { maximumFractionDigits: __props.precision, useGrouping: false },
        "onUpdate:modelValue": commit,
        onInput: _cache[0] || (_cache[0] = ($event) => isRef(edited) ? edited.value = true : edited = true),
        onFocus: _cache[1] || (_cache[1] = ($event) => isRef(edited) ? edited.value = false : edited = false)
      }), null, 16, ["model-value", "min", "max", "format-options"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index31.js.map
